import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

import GuidesScreen from '../screens/GuidesScreen';
import MapScreen from '../screens/MapScreen';
import NewsScreen from '../screens/NewsScreen';
import type { RootStackParamList } from '../types/navigation';

// The screens are switched with the buttons floating on top of them (see
// MapWrapper and ArticleList), so no header/toolbar is rendered: the map is
// the initial route and news/guides are pushed on top of it.
const Stack = createNativeStackNavigator<RootStackParamList>();

const StackNavigator = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="Map" component={MapScreen} />
      <Stack.Screen name="News" component={NewsScreen} />
      <Stack.Screen name="Guides" component={GuidesScreen} />
    </Stack.Navigator>
  );
};

export default StackNavigator;
